<script setup lang="ts">
import CraneButton from '@/components/shared/CraneButton.vue'

// pinia store instances
const errorRecoveryStore = useErrorRecoveryStore()

const retry = async () => {
    try {
        await errorRecoveryStore.retryFailedActions()
    } catch (error: unknown) {
        let errorMessage = 'An unexpected error occurred.'
        if (typeof error === 'string') {
            errorMessage = error // If a string was thrown
        } else if (
            typeof error === 'object' &&
            error !== null &&
            'message' in error &&
            typeof (error as { message: unknown }).message === 'string'
        ) {
            // If a custom object with a 'message' property was thrown
            const customError = error as { message: string }
            errorMessage = customError.message
        }

        showToastNotification({
            title: 'Error',
            description: errorMessage,
            color: 'error',
        })
    }
}
</script>

<template>
    <div class="flex flex-col items-center justify-center gap-4 p-4">
        <UPageCard class="w-full max-w-md">
            Snap! A critical error happened
            <hr />
            <CraneButton
                :avatar="{
                    src: 'https://github.com/nuxt.png',
                }"
                size="md"
                color="--color-neutral-700"
                variant="outline"
                @click="retry()"
            >
                Retry
            </CraneButton>
        </UPageCard>
    </div>
</template>
